
export default[
    //改制列表
    {
        path: '/chanp/reform',
        component: () => import( '@/views/chanp/reform/reformList.vue'),
        meta: {
            title: '改制单列表',
            isTabsPage: true
        }
    },
    {
        path: '/chanp/orderSalsePrice',
        component: () => import( '@/views/chanp/reform/orderSalsePrice.vue'),
        meta: {
            title: '产品价格',
            isTabsPage: true
        }
    },
    {
        path: '/chanp/orderSalsePriceSp',
        component: () => import( '@/views/chanp/reform/orderSalsePriceSp.vue'),
    },
    //新增改制
    {
        path: '/chanp/addReform',
        component: () => import( '@/views/chanp/reform/addReform.vue'),
    },
    //查看改制
    {
        path: '/chanp/seeReform',
        component: () => import( '@/views/chanp/reform/seeReform.vue'),
    },
    //修改改制
    {
        path: '/chanp/changeReform',
        component: () => import( '@/views/chanp/reform/changeReform.vue'),
    },

    //型号经理审批改制
    {
        path: '/chanp/xinghaojlSpReform',
        component: () => import( '@/views/chanp/reform/xinghaojlSpReform.vue'),
    },

    //审批改制
    {
        path: '/chanp/spReform',
        component: () => import( '@/views/chanp/reform/spReform.vue'),
    },

    //改制列表
    {
        path: '/chanp/reformSap',
        component: () => import( '@/views/chanp/reform/reformSapList.vue'),
        meta: {
            title: '改制单汇总列表',
            isTabsPage: true
        }
    },

    //改制样机
    {
        path: '/chanp/addReformPrototype',
        component: () => import( '@/views/chanp/reform/addReformPrototype.vue'),
    },

    //改制样机
    {
        path: '/chanp/spReformPrototype',
        component: () => import( '@/views/chanp/reform/spReformPrototype.vue'),
    },
    //改制样机
    {
        path: '/chanp/seeReformPrototype',
        component: () => import( '@/views/chanp/reform/seeReformPrototype.vue'),
    },

    //改制样机列表
    {
        path: '/chanp/reformPrototypeList',
        component: () => import( '@/views/chanp/reform/reformPrototypeList.vue'),
        meta: {
            title: '样机改制列表',
            isTabsPage: true
        }
    },

]
